<template>
    <v-select
            :items="items"
            v-model="value"
            :label="label"
            item-text="name"
            @change="onChange"
            persistent-hint
            :rules="rules"
            return-object
            outlined
    ></v-select>
</template>

<script>
    import serverService from "../../service/api/serverService";

    export default {
        name: "server-select",
        props: {
            rules : {
                type : Array,
                default: []
            },
            label : {
                type : String,
                default : 'Server'
            },
            value: {
                type: Object,
                default: null
            },
        },
        created(){
            this.getServers()
        },
        data() {
            return {
                items: []
            }
        },
        methods: {
            onChange(v){
                this.$emit('input',v)
            },
            getServers() {
                serverService.getServers().then(res => this.items = res.data)
            }
        },
    }
</script>

<style scoped>

</style>